<template>
  <div
    :style="selectedDevice.containerStyles"
    :class="selectedDevice.containerClasses"
    class="transition"
  >
    <div :class="selectedDevice.classes">
      <slot></slot>
    </div>
  </div>  
</template>

<script>
  export default {
    computed: {
      devices() {
        return {
          desktop: {
            classes: [],
            styles: {}
          },
          tablet: {
            classes: ['wf-relative', 'wf-overflow-scroll', 'wf-h-full'],
            containerClasses: [
              'wf-rounded-xl', 'wf-shadow', 'wf-absolute', 'wf-inset-0', 'wf-mx-auto', 'wf-my-auto', 'wf-overflow-hidden', 'wf-mx-auto', 'wf-bg-black', 'wf-py-8', 'wf-px-2'
            ],
            containerStyles: {width: '500px',height: '667px'},
            styles: {}
          },
          phone: {
            classes: ['wf-relative', 'wf-overflow-scroll', 'wf-h-full'],
            containerClasses: [
              'wf-rounded-xl', 'wf-shadow', 'wf-absolute', 'wf-inset-0', 'wf-mx-auto', 'wf-my-auto', 'wf-overflow-hidden', 'wf-mx-auto', 'wf-bg-black', 'wf-py-8', 'wf-px-2'
            ],
            containerStyles: {width: '375px',height: '667px'},
            styles: {}
          },
        }
      },
      selectedDevice() {
        let deviceKey = Object.keys(this.devices).find(device => device == this.device)
        return this.devices[deviceKey]
      },
      device() {
        return this.$store.getters['pageModule/device']
      },
    },
  }
</script>

<style scoped>
    .transition {
        transition: width .3s
    }
</style>